import Dialog from '../Dialog/Dialog';
import EditorButton from '../editor/EditorButton/EditorButton';
import type { HelpScenario } from '~/systems/help';

interface HelpContentProps {
  scenario: HelpScenario;
  currentHelpIdx: number | null;
  onConfirm: () => void;
  onClose: () => void;
  onPrevious: () => void;
}

export default function HelpContent({
  scenario,
  currentHelpIdx,
  onConfirm,
  onClose,
  onPrevious
}: HelpContentProps) {
  return (
    <Dialog
      title={scenario.header}
      variant="white"
      onClose={onClose}
      body={<>{scenario.content}</>}
      footer={
        <>
          {currentHelpIdx !== null && currentHelpIdx > 1 && (
            <EditorButton
              key={`help-previous-${currentHelpIdx}`}
              kind="action"
              onClick={onPrevious}
            >
              Previous
            </EditorButton>
          )}
          <EditorButton
            key={`help-next-${currentHelpIdx}`}
            kind="action"
            onClick={onConfirm}
          >
            Got it
          </EditorButton>
        </>
      }
    />
  );
}
